module.exports = __webpack_public_path__ + "img/hm.e875a51.svg";